import { configureStore } from "@reduxjs/toolkit"
import showCookieSettingsReducer from "./showCookieSettingsSlice"

const createStore = () =>
  configureStore({
    reducer: {
      showCookieSettings: showCookieSettingsReducer,
    },
  })

export default createStore
